import React from 'react'
import { Tabs, TabList, Tab, TabPanels, TabPanel, Stack, Heading, Icon, Text } from '@chakra-ui/react'
import { FaWallet } from 'react-icons/fa'
import SubscriptionDetails from './SubscriptionDetails'
import History from './History'
import Usage from './Usage'

export default function Billing() {
  return (
    <Stack w={'full'} justify={"center"} align={"center"} spacing={6}>
      <Stack
        direction={{ base: 'column', md: 'column', lg: 'column', xl: 'row' }}
        justify={'space-between'}
        boxShadow={'base'}
        rounded={'xl'}
        w={'98%'}
        p={4}
        spacing={{ base: 6, md: 6, lg: 6, xl: 0 }}
      >
        <Stack
          align={'flex-start'}
          justify={'start'}
          spacing={4}
        >
          <Stack direction={'row'}>
            <Icon
              as={FaWallet}
              fontSize={'5xl'}
              color={'primary.400'}
            />
            <Stack spacing={1}>
              <Heading fontSize={'xl'}>Subscription & Billing</Heading>
              <Text fontSize={'sm'}>Manage your subscription & billing details here.</Text>
            </Stack>
          </Stack>
        </Stack>
      </Stack>
      <Stack boxShadow={'base'} rounded={'xl'} w={'98%'} p={4} spacing={4}>
        <Tabs variant='enclosed'>
          <TabList>
            <Tab _selected={{ color: 'white', bg: 'primary.400' }}>Subscription Details</Tab>
            <Tab _selected={{ color: 'white', bg: 'primary.400' }}>Billing History</Tab>
            <Tab _selected={{ color: 'white', bg: 'primary.400' }}>Usage</Tab>
          </TabList>
          <TabPanels>
            <TabPanel as={Stack} spacing={2} py={6}>
              <SubscriptionDetails />
            </TabPanel>
            <TabPanel>
              <History />
            </TabPanel>
            <TabPanel>
              <Usage />
            </TabPanel>
          </TabPanels>
        </Tabs>
      </Stack>
    </Stack>
  )
}